// Contact form submission. The marketing site has no backend of its own, so the
// form posts directly to a Formspree endpoint, which handles spam filtering,
// storage, and email forwarding. The form id is a public endpoint identifier
// (safe to ship in the client bundle) and is read from VITE_FORMSPREE_FORM_ID.

export interface ContactFormValues {
  name: string;
  email: string;
  message: string;
  // Hidden field a real person never fills. Bots that auto-fill every input
  // trip it, and we drop their submission without sending anything.
  honeypot: string;
}

export type ContactSubmitResult = { ok: true } | { ok: false; error: string };

const FORMSPREE_ENDPOINT = 'https://formspree.io/f/';

export const CONTACT_NOT_CONFIGURED =
  'The contact form is not set up yet. Please try again later.';
export const CONTACT_SEND_FAILED =
  'Something went wrong sending your message. Please try again.';

export async function submitContact(
  values: ContactFormValues,
  formId: string | undefined
): Promise<ContactSubmitResult> {
  // Honeypot tripped: report success so the bot moves on, but send nothing.
  if (values.honeypot.trim() !== '') {
    return { ok: true };
  }

  if (!formId) {
    return { ok: false, error: CONTACT_NOT_CONFIGURED };
  }

  const body = new FormData();
  body.append('name', values.name);
  body.append('email', values.email);
  body.append('message', values.message);

  let response: Response;
  try {
    response = await fetch(`${FORMSPREE_ENDPOINT}${formId}`, {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body,
    });
  } catch {
    return { ok: false, error: CONTACT_SEND_FAILED };
  }

  if (response.ok) {
    return { ok: true };
  }

  return { ok: false, error: CONTACT_SEND_FAILED };
}
